import React from 'react';
import { HeroMenuComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import SlideMenu from '../SlideMenu';

const HeroMenuUiComponent = ({ uiComponent }: UiComponentElementInterface<HeroMenuComponentInterface>) => {
  return (
    <div
      className={`relative w-full transition-all`}
      style={{
        color: uiComponent?.styling?.textColor || '#000',
      }}>
      <div className={`${uiComponent?.customStyling?.topSpace ? 'pt-32 pb-32 ' : ''} `} style={{ backgroundColor: 'transparent', zIndex: 20 }}>
        <div className="flex flex-col @md:flex-row @md:space-x-4 w-full justify-center text-center text-3xl font-semibold">
          {uiComponent?.preText && (
            <div
              dangerouslySetInnerHTML={{
                __html: uiComponent?.preText,
              }}
            />
          )}

          {
            // check if string only contains spaces
            uiComponent?.postText && /\S/.test(uiComponent?.postText) && (
              <div
                className="bg-buttons-main"
                dangerouslySetInnerHTML={{
                  __html: uiComponent?.postText,
                }}
              />
            )
          }
        </div>
        {/* <PBSlideMenu uiComponent={uiComponent} className="mt-12" /> */}
        <SlideMenu className={`${uiComponent?.preText || uiComponent?.postText ? 'mt-12' : ''}`} />
      </div>
    </div>
  );
};

export default HeroMenuUiComponent;
